import { useTranslation } from 'react-i18next'
import { useNavigation } from '@react-navigation/native'
import React, { FC } from 'react'
import { Spacer } from '../../../../ui/atoms'
import { ILoanPaymentPlanModel } from '@linqpal/models'
import { IDownPaymentDetails } from '@linqpal/models/src/types/routes'
import { PaymentStepContainer } from './PaymentStepContainer'
import { InvoiceCreditPaymentForm } from '../Credit/Payment/InvoiceCreditPaymentForm'

interface IProps {
  invoiceIds: string[]
  paymentPlan: ILoanPaymentPlanModel
  downPayment: IDownPaymentDetails | null
  onSuccess: () => void
  onBack: () => void
  onClose: () => void
}

export const PayInvoiceStep: FC<IProps> = ({
  invoiceIds,
  paymentPlan,
  downPayment,
  onSuccess,
  onBack,
  onClose,
}) => {
  const { t } = useTranslation('global')
  const navigation = useNavigation()

  return (
    <PaymentStepContainer
      title={t('payInvoice.pay-invoice')}
      onBack={onBack}
      onClose={onClose}
    >
      <Spacer height={38} />
      <InvoiceCreditPaymentForm
        invoiceIds={invoiceIds}
        paymentPlan={paymentPlan}
        downPayment={downPayment}
        navigation={navigation}
        onSuccess={onSuccess}
      />
    </PaymentStepContainer>
  )
}
